export default __webpack_public_path__ + "static/media/step1.b8abd027.svg";